import { USER_PROFILE_ENDPOINTS } from '../../components/TopNavigationHeader/services/endpoints';
import { SHARED_ENDPOINTS } from '../../constants/sharedEnpoints';
import { USER_ENDPOINTS } from '../../constants/user/endpoints';
import { ApiClient } from '../../interfaces/ApiClient';
import { GetUsersPayload, UserInterface } from '../../interfaces/user/UserInterfaces';
import { getQueryParamsString } from '../apiUtils';

const { CATEGORIES } = SHARED_ENDPOINTS;
const { USERS } = USER_ENDPOINTS;
const { USER_PROFILE } = USER_PROFILE_ENDPOINTS;

export const getUsers = (api: ApiClient) => api.get(USERS);

export const getUserById = (api: ApiClient, payload: GetUsersPayload) => {
  const queryString = getQueryParamsString(payload);
  return api.get(`${USERS}?${queryString}`);
};

export const editUser = (
  api: ApiClient,
  userId: string,
  userData: Partial<UserInterface>
) => api.put(`${USERS}/${userId}`, { user: userData });


export const deleteUser = (api: ApiClient, userId: string) => api.delete(`${USERS}/${userId}`);


export const createUser = (api: ApiClient, newUserData: Partial<UserInterface>) => api.post(`${USERS}`, { user: newUserData });


export const getUserProfile = (api: ApiClient) => api.get(USER_PROFILE);


export const getCategories = (api: ApiClient) => api.get(CATEGORIES);
